<template>

    <div id="chat-messages-wrapper">

        <div v-if="chatReady" id="chat-transcript">
            
            <div :key="`chat-msg-initial`">
                <ChatMessage :message="this.initialBotMessage"></ChatMessage>
            </div>

            <div 
            v-for="message in currentChatMessages"
            :key="`chat-msg-${message.chatMessageId}`">

                <ChatMessage :message="message"></ChatMessage>

            </div>

            <ThinkingIndicator v-if="responsePending"></ThinkingIndicator>

            <div class="buffer"></div>
        
        </div>

    </div>

</template>

<script>
    import ChatMessage from "./message.vue";
    import ThinkingIndicator from "@/components/thinking.vue";

    import { mapGetters } from "vuex";

    export default {
        name: 'ChatMessages',
        components: {
            ChatMessage,
            ThinkingIndicator,
        },
        mounted() {
            this.$emit('new-message');
        },
        updated() {
            this.$emit('new-message');
        },
        computed: {
            ...mapGetters([
                "appLoading",
                "currentChat",
                "currentChatMessages", 
                "responsePending",
            ]),
            chatReady() {
                return !this.appLoading && this.currentChat.isLoaded;
            },
            noMessages() {
                return !this.currentChatMessages.length;
            },
            initialBotMessage() {
                return {
                    chatMessageId: 0,
                    role: "assistant",
                    message: this.$t('INITIAL_BOT_MESSAGE'),
                    sent: this.currentChat.created,
                }
            }
        },
    }
</script>